<user-navigation></user-navigation>

<div class="container">
    <div id="top"></div>
    <div class="row">
        <div class="col-md-12 col-lg-10 billing-history-box mx-auto mx-3">
            <div id="page-redirection">
                <a routerLink="/user/profile">
                    <img src="../../../../assets/images/arrows/back_arrow.png">
                    Back to Account
                </a>
            </div>
            <h3 class="display-4 box-title">Billing History</h3>
            <div class="d-none d-sm-block d-md-block">
                <table class="table table-borderless mt-md-5 mt-5">
                    <thead>
                        <tr>
                            <th>Date</th>
                            <th>Type</th>
                            <th>Payment Method</th>
                            <th>Total</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let item of billings | paginate:{itemsPerPage: 5, currentPage:p}">
                          <td>{{item.created * 1000 | date:'dd/MM/yyyy':'+1200'}}</td>
                          <td>{{ item.type == "subscription" ? "Take a Breath Subscription" : "Breathing Device" }}</td>
                          <td>**** **** **** {{item.last_four}}</td>
                          <td>${{item.amount}}</td>
                        </tr>
                    </tbody>
                </table>
                <div id="pagination" class="text-center" *ngIf="billings">
                  <pagination-controls (pageChange)="p=$event"></pagination-controls>
                </div>
            </div>

            <div class="mobile-billing-history mb-5 mb-md-5 d-block d-sm-none">
                <ul class="mt-5 mt-md-5">
                    <li *ngFor="let item of billings | paginate:{itemsPerPage: 5, currentPage:p}">
                        <div class="mt-3 mt-md-3">
                            <span class="font-weight-bold">{{item.created * 1000 | date:'dd/MM/yyyy':'+1200'}}</span>
                            <span class="font-weight-bold pull-right">${{item.amount}}</span>
                        </div>
                        <p>{{ item.type == "subscription" ? "Take a Breath Subscription" : "Breathing Device" }}</p>
                        <p class="mb-3 mb-md-3">**** **** **** {{item.last_four}}</p>
                    </li>
                </ul>
            </div>

        </div>
    </div>

    <!-- Modal Loader -->
    <modal-loader [modalText]="modalText"></modal-loader>

</div>
